export default {
  name: 'ToastComp'
};